import apiClient, { unwrap } from './client'
import type { TlsConfig, TlsCertInfo } from './types'

export const tlsApi = {
  getConfig() {
    return unwrap<TlsConfig>(apiClient.get('/tls/config'))
  },

  putConfig(data: Partial<TlsConfig>) {
    return unwrap<unknown>(apiClient.put('/tls/config', data))
  },

  uploadCert(certFile: File, keyFile: File) {
    const form = new FormData()
    form.append('cert', certFile)
    form.append('key', keyFile)
    return unwrap<unknown>(apiClient.post('/tls/certificates', form))
  },

  testCert() {
    return unwrap<{ ok: boolean; cert?: TlsCertInfo; error?: string }>(
      apiClient.post('/tls/test'),
    )
  },

  reload() {
    return unwrap<{ message: string }>(apiClient.post('/tls/reload'))
  },

  acmeStatus() {
    return unwrap<unknown>(apiClient.get('/tls/acme/status'))
  },

  issueAcme() {
    return unwrap<{ message: string }>(apiClient.post('/tls/acme/issue'))
  },
}
